<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-shield-account
                </v-icon>
              </v-col>
              <v-col>
                <div class="headline font-weight-black">
                  <p v-if="!newPasswordSuccessMessage">
                    Neues Passwort eingeben!
                  </p>
                  <p v-else class="green--text">
                    Neues Passwort erfolgreich gespeichert!
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col v-if="!newPasswordSuccessMessage">
                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Neues Passwort eingeben"
                  v-model="mPassword"
                  name="password"
                  label="Neues Passwort"
                  required
                  :rules="passwordRules"
                  :error-messages="errorMessagePassword"
                  :type="showPW ? 'password' : 'text'"
                  @click:append="() => (showPW = !showPW)"
                  :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
                />

                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Neues Passwort eingeben"
                  v-model="mPassword2"
                  name="password2"
                  label="Neues Passwort wiederholen"
                  required
                  data-vv-as="password"
                  :rules="password2Rules"
                  :error-messages="errorMessagePassword2"
                  :type="showPW2 ? 'password' : 'text'"
                  @click:append="() => (showPW2 = !showPW2)"
                  :append-icon="showPW2 ? 'mdi-eye' : 'mdi-eye-off'"
                />

                <my-alert
                  v-if="this.$store.state.error"
                  type="error"
                  :error="this.$store.state.error"
                  :title="this.$store.state.errorTitle"
                />
              </v-col>
              <v-col
                v-else
              >
                <p class="text-center green--text title">
                  Glückwunsch! Der Server hat Dein Passwort erfolgreich gespeichert.
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions
            v-show="!newPasswordSuccessMessage"
            class="text-center mb-6 pb-6"
          >
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelPassword()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              outlined
              large
              class="primary--text mx-auto"
              @click.native.stop="savePassword()"
              :loading="this.$store.state.loading"
            >
              speichern <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'

export default {
  name: 'Newpassword',
  metaInfo: {
    title: 'Neues Passwort'
  },
  data () {
    return {
      newPasswordSuccessMessage: false,
      newPasswordProcess: false,
      showPW: true,
      showPW2: true,
      mPassword: '',
      mPassword2: '',
      passwordRules: [],
      password2Rules: [],
      errorMessagePassword: [],
      errorMessagePassword2: []
    }
  },
  methods: {
    validateAll: (password, passwordCheck) => {
      const ret = { status: true }

      if (password.length == null || password.length < 8) {
        ret.password = true
        ret.status = false
      }
      if (password !== passwordCheck) {
        ret.passwordCheck = true
        ret.status = false
      }

      return ret
    },
    cancelPassword: function () {
      this.mPassword = ''
      this.mPassword2 = ''
      this.$router.replace({ path: '/settings' })
    },
    savePassword: async function () {
      this.$store.commit(ROOT_LOADING, true)
      const check = this.validateAll(this.mPassword, this.mPassword2)
      this.passwordRules = []
      this.password2Rules = []
      this.errorMessagePassword = []
      this.errorMessagePassword2 = []

      if (!check.status) {
        // show errors
        this.newPasswordProcess = false

        if (check.password) {
          this.passwordRules = this.errorMessagePassword = ['Passwort erforderlich, mindestens 8 Zeichen!']
        }

        if (check.passwordCheck) {
          this.password2Rules = this.errorMessagePassword2 = ['Passwörter stimmen nicht überein']
        }
        this.$store.commit(ROOT_LOADING, false)
        return false
      }

      const newPassword = await this.$store.dispatch('managerStore/saveNewPassword', {
        password: this.mPassword,
        password2: this.mPassword2
      })
      if (newPassword) {
        this.newPasswordSuccessMessage = true
      }
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>
